import { html } from '@/helpers/html-template'
import { type AttributesCallout, CalloutType } from './attributes'
import { EditorClasses } from '@/styles'
import { guideIconHtml } from '@scalar-org/guide-icons'
import { toVueComponent } from '@scalar-org/vue-render'

export function guideCalloutHtml(props: AttributesCallout) {
  const calloutClasses = [
    'callout',
    EditorClasses.Callout,
    `callout__${props.type ?? 'info'}`,
  ]

  // Handle conditional classes with standard JS instead of Vue directives
  const iconClasses = ['callout-content__icon']
  if (props.isEditable) {
    iconClasses.push('callout-content__icon-editable')
  }

  // data-scalar-name is used to identify the element when looking for click events
  return html`
<div class="${calloutClasses.join(' ')}">
  <div class="callout-content">
    <!-- Callout Icon -->
    <div
      data-scalar-name="callout-icon"
      class="${iconClasses.join(' ')}"
    >
      ${props.icon ? guideIconHtml({ src: props.icon }) : baseCalloutIcons(props.type)}
    </div>
    <!-- Callout text content -->
    <div class="callout-content__text">
      <ssg-children />
    </div>
  </div>
</div>
  `
}

/** Scalar Button wrapped in Vue for usage in the Tiptap extensions */
export const ScalarCalloutVue = toVueComponent<AttributesCallout>(
  guideCalloutHtml,
  {
    type: String,
    icon: String,
    isEditable: Boolean,
  },
)

/** Returns the icon SVG for a gi */
function baseCalloutIcons(type: CalloutType) {
  const danger = html`
    <svg
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8.5-4a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 1 0V4Zm-2 2a.5.5 0 0 0 0 1h1v4.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 0-1h-1V6.5A.5.5 0 0 0 8 6H6.5Z"
        fill="currentColor"
        fill-rule="nonzero" />
    </svg>`
  const warning = html`
    <svg
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8.5-4a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 1 0V4Zm-2 2a.5.5 0 0 0 0 1h1v4.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 0-1h-1V6.5A.5.5 0 0 0 8 6H6.5Z"
        fill="currentColor"
        fill-rule="nonzero" />
    </svg>`
  const neutral = html`
    <svg
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8.5-4a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 1 0V4Zm-2 2a.5.5 0 0 0 0 1h1v4.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 0-1h-1V6.5A.5.5 0 0 0 8 6H6.5Z"
        fill="currentColor"
        fill-rule="nonzero" />
    </svg>`
  const info = html`
    <svg
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8.5-4a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 1 0V4Zm-2 2a.5.5 0 0 0 0 1h1v4.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 0-1h-1V6.5A.5.5 0 0 0 8 6H6.5Z"
        fill="currentColor"
        fill-rule="nonzero" />
    </svg>`
  const success = html`
    <svg
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8.5-4a.5.5 0 0 0-1 0v.5a.5.5 0 0 0 1 0V4Zm-2 2a.5.5 0 0 0 0 1h1v4.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 0-1h-1V6.5A.5.5 0 0 0 8 6H6.5Z"
        fill="currentColor"
        fill-rule="nonzero" />
    </svg>`

  const icons = {
    [CalloutType.Danger]: danger,
    [CalloutType.Warning]: warning,
    [CalloutType.Neutral]: neutral,
    [CalloutType.Info]: info,
    [CalloutType.Success]: success,
  }
  return icons[type] ?? neutral
}
